<template>
	<div>
		<el-select :value="value" :size="size" :placeholder="placeholder" :disabled="disabled" @change="change"
			filterable clearable>
			<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
			</el-option>
		</el-select>
		<!-- 		<template v-if="el">
			<el-select :value="value" :size="size" :placeholder="placeholder" :disabled="disabled" @change="change" filterable>
				<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
				</el-option>
			</el-select>
		</template>
		<template v-else>
			<vxe-select :value="value" :size="size" :placeholder="placeholder" :disabled="disabled" @change="change" filterable>
				<vxe-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
				</vxe-option>
			</vxe-select>
		</template>	 -->
	</div>
</template>

<script>
	import selectBase from '@_system/components/base/select.js'
	export default {
		mixins: [selectBase],
		props: {
			extra: {
				type: Object,
				default: () => {
					return {}
				}
			},
		},
		data() {
			return {
				ready: false,
				options: [],
			}
		},
		created() {

		},
		watch: {

		},
		computed: {

		},

		methods: {
			list() {
				let obj = {
					currentPage: -1,
				}
				obj = {
					...obj,
					...this.extra
				}
				this.$api.module.list(obj).then((res) => {
					let options = []

					res.list.forEach((item) => {
						options.push({
							value: item.id,
							label: item.name
						})
					})
					this.options = options
					this.finish()
				})
			}
		}
	}
</script>
